export default "__VITE_ASSET__DZ4dJFPT__"